import { useContext, useState, useEffect } from 'react';
import InputText from '../../../components/inputComponents/InputText';
import { GlobalContext } from '../../../components/contexts';

const ConsultImpvWrite = ({ rslt, onChangeRslt, svcObj }) => {
  const [tables, setTables] = useState([]);
  const [valueObj, setValueObj] = useState({ ...rslt });
  const store = useContext(GlobalContext);

  useEffect(() => {
    if (rslt.improvementList && rslt.improvementList.length > 0) {
      setTables(
        rslt.improvementList.map(improvement => ({
          key: improvement.exprtCnsltDtlId,
          menuIndex: rslt.index,
          valueObj: { ...improvement, key: improvement.exprtCnsltDtlId },
        }))
      );
    } else {
      setTables([
        {
          key: Date.now(),
          menuIndex: rslt.index,
          valueObj: {
            exprtCnsltId: rslt.exprtCnsltId,
            exprtAnlsId: rslt.exprtAnlsId,
            exprtAnlsDtlId: rslt.exprtAnlsDtlId,
            riskDcrsYn: 'N',
            techYn: 'N',
            mngYn: 'N',
            etcYn: 'N',
            cnsltCn: '',
          },
        },
      ]);
    }
  }, [rslt]);

  const handleAddTable = () => {
    const lastValueObj =
      tables.length > 0 ? tables[tables.length - 1].valueObj : rslt;

    setTables(prevTables => [
      ...prevTables,
      {
        key: Date.now(),
        menuIndex: rslt.index,
        valueObj: {
          exprtCnsltId: rslt.exprtCnsltId,
          exprtAnlsId: rslt.exprtAnlsId,
          exprtAnlsDtlId: rslt.exprtAnlsDtlId,
          riskDcrsYn: 'N',
          techYn: 'N',
          mngYn: 'N',
          etcYn: 'N',
          cnsltCn: '',
        },
      },
    ]);
  };

  const handleDeleteTable = index => {
    const updatedTables = tables.filter((_, i) => i !== index);
    setTables(updatedTables);

    if (onChangeRslt) {
      onChangeRslt(rslt.index, null, null, null, updatedTables);
    }
  };
  const menuIndex = rslt.index;
  const onChangeTableValue = (index, model, value) => {
    const updatedTables = tables.map((table, i) =>
      i === index
        ? { ...table, valueObj: { ...table.valueObj, [model]: value } }
        : table
    );
    setTables(updatedTables);

    onChangeRslt && onChangeRslt(menuIndex, index, model, value, updatedTables);
  };

  return (
    <>
      <div className="data-table">
        <table>
          <caption>단위 작업에 해당되는 근본원인 및 문제점 내용입니다.</caption>
          <tbody>
            <tr>
              <td className="bg--skyblue">
                <span className="txt--red">*</span> 근본원인
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id="humanFactor"
                  name="humanFactor"
                  checked={valueObj.anlsPrYn === 'Y'}
                  className={'readOnly'}
                  disabled
                  onChange={e => {
                    onChangeValueObj('anlsPrYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor="humanFactor">인적요인</label>
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id="materialFactor"
                  name="materialFactor"
                  checked={valueObj.anlsPhyYn === 'Y'}
                  className={'readOnly'}
                  disabled
                  onChange={e => {
                    onChangeValueObj('anlsPhyYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor="materialFactor">물적·설비적 요인</label>
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id="environFactor"
                  name="environFactor"
                  checked={valueObj.anlsEnvYn === 'Y'}
                  className={'readOnly'}
                  disabled
                  onChange={e => {
                    onChangeValueObj('anlsEnvYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor="environFactor">환경적 요인</label>
              </td>
            </tr>
            <tr>
              <td className="bg--skyblue">
                <span className="txt--red">*</span> 현황 및 문제점
              </td>
              <td colSpan={3}>
                <textarea
                  aria-label="현황 및 문제점"
                  className="form-control sm"
                  style={{ height: '20rem', lineHeight: '1.5' }}
                  value={valueObj.anlsCn}
                  required={true}
                  readOnly={true}
                  maxLength={4000}
                  onChange={e => {
                    onChangeValueObj('anlsCn', e.target.value);
                  }}
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="data-table">
        <div
          className="btn-group"
          style={{ marginTop: '2rem', marginBottom: '0.5rem' }}
        >
          {svcObj.cnsltSttsCd === 'CNSLT01' &&
          store.store?.authrtId === 'EX' ? (
            <button type="button" className="btn sm" onClick={handleAddTable}>
              개선사항 추가
            </button>
          ) : null}
        </div>

        {tables.map((table, index) => (
          <table key={table.key} style={{ marginBottom: '1rem' }}>
            <caption>컨설팅 개선방안 및 개선사항을 나타내는 표입니다.</caption>
            <tbody>
              <tr>
                <td className="bg--skyblue">
                  <span className="txt--red">*</span> 개선 방안
                </td>
                <td className="form-check sm">
                  <input
                    type="checkbox"
                    id={`unRisk-${index}`}
                    name="unRisk"
                    checked={table.valueObj.riskDcrsYn === 'Y'}
                    className={'readOnly'}
                    disabled={
                      svcObj.cnsltSttsCd != 'CNSLT01' ||
                      store.store?.authrtId != 'EX'
                    }
                    onChange={e =>
                      onChangeTableValue(
                        index,
                        'riskDcrsYn',
                        e.target.checked ? 'Y' : 'N'
                      )
                    }
                  />
                  <label htmlFor={`unRisk-${index}`}>위험성 제거/저감</label>
                </td>
                <td className="form-check sm">
                  <input
                    type="checkbox"
                    id={`tech-${index}`}
                    name="tech"
                    checked={table.valueObj.techYn === 'Y'}
                    className={'readOnly'}
                    disabled={
                      svcObj.cnsltSttsCd != 'CNSLT01' ||
                      store.store?.authrtId != 'EX'
                    }
                    onChange={e =>
                      onChangeTableValue(
                        index,
                        'techYn',
                        e.target.checked ? 'Y' : 'N'
                      )
                    }
                  />
                  <label htmlFor={`tech-${index}`}>기술적</label>
                </td>
                <td className="form-check sm">
                  <input
                    type="checkbox"
                    id={`manage-${index}`}
                    name="manage"
                    checked={table.valueObj.mngYn === 'Y'}
                    className={'readOnly'}
                    disabled={
                      svcObj.cnsltSttsCd != 'CNSLT01' ||
                      store.store?.authrtId != 'EX'
                    }
                    onChange={e =>
                      onChangeTableValue(
                        index,
                        'mngYn',
                        e.target.checked ? 'Y' : 'N'
                      )
                    }
                  />
                  <label htmlFor={`manage-${index}`}>관리적</label>
                </td>
                <td className="form-check sm">
                  <input
                    type="checkbox"
                    id={`etc-${index}`}
                    name="etc"
                    checked={table.valueObj.etcYn === 'Y'}
                    className={'readOnly'}
                    disabled={
                      svcObj.cnsltSttsCd != 'CNSLT01' ||
                      store.store?.authrtId != 'EX'
                    }
                    onChange={e =>
                      onChangeTableValue(
                        index,
                        'etcYn',
                        e.target.checked ? 'Y' : 'N'
                      )
                    }
                  />
                  <label htmlFor={`etc-${index}`}>기타, 보호구 등</label>
                </td>
                <td style={{ textAlign: 'right' }}>
                  {svcObj.cnsltSttsCd === 'CNSLT01' &&
                  store.store?.authrtId === 'EX' &&
                  tables.length > 1 ? (
                    <button
                      type="button"
                      className="btn xsm secondary"
                      onClick={() => handleDeleteTable(index)}
                    >
                      삭제
                    </button>
                  ) : null}
                </td>
              </tr>
              <tr>
                <td className="bg--skyblue">
                  <span className="txt--red">*</span> 개선 사항
                  <br />(
                  {table.valueObj.cnsltCn ? table.valueObj.cnsltCn.length : 0} /
                  4000)
                </td>
                <td colSpan={5}>
                  <textarea
                    aria-label="개선 사항"
                    className="form-control sm"
                    style={{ height: '10rem', lineHeight: '1.5' }}
                    value={table.valueObj.cnsltCn}
                    required={true}
                    readOnly={
                      svcObj.cnsltSttsCd != 'CNSLT01' ||
                      store.store?.authrtId != 'EX'
                    }
                    placeholder="- 관련 법조항 표기 &#10;- 참고자료 출처 표기"
                    maxLength={4000}
                    onChange={e => {
                      onChangeTableValue(index, 'cnsltCn', e.target.value);
                    }}
                  ></textarea>
                </td>
              </tr>
            </tbody>
          </table>
        ))}
      </div>

      {/* <p>- 관련 법조항 표기</p>
      <p>- 참고자료 출처 표기</p> */}
    </>
  );
};

export default ConsultImpvWrite;
